import React from "react"

import {
  TechnicalIcon,
  BackupIcon,
  UxAuditsIcon,
  AdministrationIcon,
  DesignIcon,
  SecurityIcon,
  UpdateIcon,
  RecommendationsIcon,
  DevelopmentIcon,
  ResponseIcon,
  ImplementationIcon,
  RiskFreeIcon,
} from "components/icons"

const getAnimatedIcon = (name, url) => {
  switch (name) {
    case "Technical Support":
    case "Wsparcie techniczne":
      return <TechnicalIcon />
    case "Regular Backups":
    case "Tworzenie kopii zapasowych":
      return <BackupIcon />
    case "UX Audits (on request)":
    case "Audyty UX (na żądanie)":
      return <UxAuditsIcon />
    case "Administration of WordPress and WooCommerce":
    case "Administracja WordPress i WooCommerce":
      return <AdministrationIcon />
    case "Graphic Design Projects (on request)":
    case "Projekty graficzne (na żądanie)":
      return <DesignIcon />
    case "Online Security & Protection":
    case "Zabezpieczenie i ochrona":
      return <SecurityIcon />
    case "Regular Updates":
    case "Regularne aktualizacje":
      return <UpdateIcon />
    case "Expert Recommendations":
    case "Rekomendacje ekspertów":
      return <RecommendationsIcon />
    case "Web Development":
    case "Tworzenie i rozwój stron internetowych":
      return <DevelopmentIcon />
    case "Quick response time":
    case "Szybki czas odpowiedzi":
      return <ResponseIcon />
    case "Free implementation":
    case "Darmowe wdrożenie":
      return <ImplementationIcon />
    case "Risk-free":
    case "Bez ryzyka":
      return <RiskFreeIcon />
    default:
      return url
  }
}

export default getAnimatedIcon
